import type { FC, ReactNode } from 'react'

import { Button } from '@/components/generals/button'
import { benefits } from '@/constants/content'

type BenefitProps = {
    /**
     * home     – image with the floating counter, copy on the right
     * services – image only, copy on the right
     * details  – centred heading above the two columns
     */
    variant?: 'home' | 'services' | 'details'
}

const HEADING = 'Why choose NG Painting Pro?'
const SUBHEADING =
    'Honest pricing, quality materials and expert craftsmanship have been our standard since 2000, on every home and every business we paint.'

const BenefitList: FC = (): ReactNode => (
    <div className='benefit-bottom'>
        <div className='benefit-list' data-reveal-stagger='0.12'>
            {benefits.map((benefit) => (
                <div key={benefit.title} className='single-benefit'>
                    <img src={benefit.icon} loading='lazy' alt='' className='benefit-icon' />

                    <div className='benefit-title-wrapper'>
                        <p className='benefit-title'>
                            {benefit.title}
                        </p>

                        <p className='benefit-content'>
                            {benefit.content}
                        </p>
                    </div>
                </div>
            ))}
        </div>

        <Button href='/book-free-consultation' label='Get Free Estimate' />
    </div>
)

const BenefitImage: FC<{ withCounter: boolean }> = ({ withCounter }): ReactNode => (
    <div className='benefit-left' data-reveal='image'>
        <img
            src='/images/ng/gallery/kitchen-cabinets.jpg'
            loading='lazy'
            alt='Kitchen cabinets painted blue-gray with gold hardware by NG Painting Pro'
            className='benefit-image'
        />

        {withCounter && (
            <div className='benefit-counter'>
                <p className='benefit-counter-number'>
                    <span data-counter='100'>
                        100
                    </span>
                    %
                </p>

                <p className='benefit-counter-label'>
                    Customer Satisfaction
                </p>
            </div>
        )}
    </div>
)

export const Benefit: FC<BenefitProps> = ({ variant = 'home' }): ReactNode => {
    if (variant === 'details') {
        return (
            <section className='benefit-section-02 section-padding'>
                <div className='w-layout-blockcontainer container small w-container'>
                    <div className='section-content-wrapper'>
                        <div className='section-title-wrapper align-center' data-reveal>
                            <h2 className='section-title'>
                                {HEADING}
                            </h2>

                            <p className='section-subtitle benefit-02'>
                                {SUBHEADING}
                            </p>
                        </div>

                        <div className='section-content-wrapper benefit'>
                            <BenefitImage withCounter />

                            <div className='benefit-right'>
                                <BenefitList />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className='benefit-section section-padding'>
            <div className='w-layout-blockcontainer container small w-container'>
                <div className={`section-content-wrapper benefit${variant === 'services' ? ' style-02' : ''}`}>
                    <BenefitImage withCounter={variant === 'home'} />

                    <div className='benefit-right'>
                        <div className='section-title-wrapper' data-reveal='slide-left'>
                            <h2 className='section-title'>
                                {HEADING}
                            </h2>

                            <p className='section-subtitle benefit'>
                                {SUBHEADING}
                            </p>
                        </div>

                        <BenefitList />
                    </div>
                </div>
            </div>
        </section>
    )
}
